import Button from '@material-ui/core/Button';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
const InternalButtonLink = ({ to, ...rest }) => {
    const renderLink = React.useMemo(() => React.forwardRef(({ children, ...linkRest }, ref) => (React.createElement(RouterLink, { ...linkRest, ref: ref, to: to }, children))), [to]);
    return (React.createElement(Button, { ...rest, component: renderLink }, rest.children));
};
export default InternalButtonLink;
